import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import mensagens from '@/util/mensagens'
import util from '@/util'
import ListagemPedidos from '@/views/pedidos/ListagemPedidos.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'

export default {
  name: 'pedidos',
  props: {
    idEscritorio: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    cabecalho,
    pagination,
    ListagemPedidos
  },

  computed: {
    desabilitarCampos () {
      return this.flagsDeControle.carregandoDados.status
    },
    tabelaPedidosSemRegistros () {
      return this.listaPedidos.length === 0
    }
  },

  data: () => {
    return {
      listaPedidos: [],
      fields: [
        { key: 'servico', sortable: false, label: 'Serviço' },
        { key: 'data', sortable: false, label: 'Data Emissão' },
        { key: 'valor', sortable: false, label: 'Valor' }
      ],
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      },
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      }
    }
  },

  mounted () {
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    this.obterListaPedidos()
  },

  methods: {
    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },
    async obterListaPedidos () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const parametrosRequisicao = {
          'page': this.componentePaginacao.pagina,
          'registrosPorPagina': this.componentePaginacao.registrosPorPagina,
          'filtros': {
            'f_tipo': 1,
            'id_tenant': this.idEscritorio
          },
          'ordenacao': this.componenteOrdenacao
        }
        const resposta = await this.axios.post(`/escritorios/escritorio/pedidos`, parametrosRequisicao)
        if (resposta.data.retorno.dados.length > 0) {
          this.listaPedidos = resposta.data.retorno.dados
          this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
          this.componentePaginacao.ultimaPagina = resposta.data.retorno.paginacao.ultimaPagina
        }
      } catch (e) {
        console.log(e)
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    buscarRegistros () {
      this.obterListaPedidos()
      this.componentePaginacao.pagina = 1
    },
    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaPedidos()
    }
  }
}
